import { useState, useEffect, useContext } from "react";
import { PumpContext } from "../context/PumpContext";

function Pump({
  tag = "P-101A",
  x = 100,
  y = 100,
  size = 80,
  bladeCount = 3,
  bladeLength = 22,
  rpm = 0,
  baseRPM = 1800,
  onClick,
  style = {}
}) {
  const [angle, setAngle] = useState(0);

  const ctx = useContext(PumpContext);
  const running = ctx?.pumpData?.[tag]?.running ?? false;

  const speedFactor = running ? rpm / baseRPM : 0;

  useEffect(() => {
    if (!running) return;

    const interval = setInterval(() => {
      setAngle(prev => prev + (2 + speedFactor * 8));
    }, 50);

    return () => clearInterval(interval);
  }, [running, speedFactor]);

  const blades = [];
  for (let i = 0; i < bladeCount; i++) {
    const rotation = (360 / bladeCount) * i;

    blades.push(
      <rect
        key={i}
        x={-3}
        y={-bladeLength}
        width={6}
        height={bladeLength}
        rx={2}
        fill="white"
        transform={`rotate(${rotation})`}
      />
    );
  }

  return (
    <div
      style={{
        position: "absolute",
        left: x,
        top: y,
        width: size,
        cursor: "pointer",
        ...style
      }}
      onClick={() => onClick && onClick(tag)}
    >
      <svg width={size} height={size} viewBox="-50 -50 100 100">
        <circle
          cx="0"
          cy="0"
          r="40"
          fill={running ? "lime" : "red"}
          stroke="black"
          strokeWidth="3"
        />

        <g transform={`rotate(${angle})`}>
          {blades}
        </g>

        <circle cx="0" cy="0" r="6" fill="black" />
      </svg>

      
    </div>
  );
}

export default Pump;